import { Avatar } from "@design-system/DataDisplay/Avatar";
import { Tooltip } from "@design-system/DataDisplay/Tooltip";
import { FlexRow } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import { FC } from "react";

type Assignee = {
    firstName: string;
    lastName: string;
    profilePictureUrl?: string | null;
};

export const AssigneesUserAvatar: FC<{
    assignees: Assignee[];
}> = ({ assignees }) => {
    return (
        <FlexRow alignItems="center" gap="1">
            <FlexRow alignItems="center" className="-space-x-1">
                {assignees?.slice(0, 4).map((assignee, index) => (
                    <Tooltip key={index}>
                        <Tooltip.Trigger className="cursor-default">
                            <Avatar
                                className="border border-white"
                                variant="circle"
                                size="sm"
                                imageUrl={
                                    assignee.profilePictureUrl || undefined
                                }
                                letter={assignee.firstName.charAt(0)}
                            />
                        </Tooltip.Trigger>
                        <Tooltip.Content>
                            <Text variant="body-sm-bold">
                                {assignee.firstName} {assignee.lastName}
                            </Text>
                        </Tooltip.Content>
                    </Tooltip>
                ))}
            </FlexRow>
            {assignees?.length > 4 && (
                <Text variant="body-sm-bold">+{assignees.slice(4).length}</Text>
            )}
        </FlexRow>
    );
};
